import React, { useState } from 'react';
import styled from 'styled-components';
import { FaArrowCircleUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.addEventListener('scroll', checkScrollTop);

  return (
    <Button show={showScroll}>
      <FaArrowCircleUp color="#549E2F" onClick={scrollTop} size={40} />
      <span>VOLTAR AO TOPO</span>
    </Button>
  );
};

export default ScrollToTopButton;

export const Button = styled.button`
  position: fixed;
  z-index: 999999999;
  bottom: 60px;
  right: 40%;
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  border: none;
  background-color: transparent;
  color: #549e2f;

  animation: fadeIn 0.3s;
  transition: opacity 0.4s;
  opacity: 0.5;

  :hover {
    opacity: 1;
    font-weight: bold;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`;
